import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

// * Main Wrapper for the hero banner
export const EssoCampaignHeroVariationsWrapperStyles = css`
  &.esso-campaign-hero {
    padding: 20px 15px 10px;
    min-height: 515px;
    text-align: left;
    overflow: hidden;
    background: ${themeGet('colors.velvet')};
    background: linear-gradient(
      to bottom,
      ${themeGet('colors.velvet')} 75%,
      transparent 25%
    );

    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 25%;
      background-color: ${themeGet('colors.light-grey')};
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.esso-campaign-hero {
      min-height: 350px;
      padding: 30px 30px 10px;

      background: linear-gradient(
        to bottom,
        ${themeGet('colors.velvet')} 80%,
        transparent 20%
      );

      &:after {
        height: 20%;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &.esso-campaign-hero {
      padding: 70px 50px 0;

      background: linear-gradient(
        to bottom,
        ${themeGet('colors.velvet')} 85%,
        transparent 15%
      );

      &:after {
        height: 15%;
      }
    }
  }
`;

// * Styling for the Div that wraps all the text copy
export const EssoCampaignHeroVariationsContentStyles = css`
  ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
    position: relative;
    z-index: 1;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
      max-width: 50%;
    }
  }
`;

// * Styling for the heading inside the content box
export const EssoCampaignHeroVariationsTitleStyles = css`
  ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
    color: ${themeGet('colors.white')};
    font-family: ${themeGet('fonts.noir')};
    font-size: 20px;
    font-weight: ${themeGet('fontWeights.medium')};
    letter-spacing: 0;
    line-height: 25.2px;

    span {
      display: inline-block;
      margin: 20px 0;

      color: inherit;
      font-family: inherit;
      font-size: 54px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: 0;
      line-height: 37.84px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
      span {
        font-size: 63.06px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
      .pts-bubble {
        margin: 0;
        height: 50px;
        width: 48px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
      font-size: 30px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: 0;
      line-height: 45px;

      span {
        font-size: 112.61px;
        font-weight: ${themeGet('fontWeights.medium')};
        letter-spacing: 0;
        line-height: 67.57px;
      }

      .pts-bubble {
        height: 61px;
        width: 70px;
      }
    }
  }
`;

// * Intro body copy below the heading in the hero
export const EssoCampaignHeroVariationsIntroStyles = css`
  ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
    margin: 15px 0 0;
    width: 100%;

    p {
      color: ${themeGet('colors.white')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
      margin: 30px 0 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
      margin: 46px 0 0;
    }
  }
`;

// * The Div that wraps the CTA in the Hero
export const EssoCampaignHeroVariationsCTAWrapperStyles = css`
  ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
    padding-top: 14rem;
    align-items: center;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      padding-top: 70vw;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding-top: 80px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    }
  }
`;

export const EssoCampaignHeroVariationsMediaContainerStyles = css`
  ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
    margin: 0;
    z-index: 1;
    position: absolute;
    right: 50%;
    transform: translateX(50%);
    bottom: 90px;
    width: calc(100% - 40px);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
      width: 45%;
      min-width: 325px;
      transform: none;
      top: auto;
      right: 0;
      bottom: 0;
      left: auto;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
      width: 520px;
      position: absolute;
      top: auto;
      right: 0;
      bottom: 0;
      left: auto;
      transform: none;
    }
  }
`;

export const EssoCampaignHeroVariationsHeroImageStyles = css`
  ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
    margin: 0;
    height: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${EssoCampaignHeroVariationsWrapperStyles}.esso-campaign-hero & {
      margin: 0;
      height: 270px;
      height: 100%;
      width: 100%;
    }
  }
`;
